/**
 * @see https://umijs.org/docs/max/access#access
 * */
import { OMS_PERMISSION_ADMIN, OMS_PERMISSION_VIEW_REPORT, OMS_PERMISSION_MANAGE_INVENTORY } from '@/../config/const';
import { getScopes } from './utils/token';

export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  const scopes = getScopes();

  return {
    canAdmin: currentUser && scopes.includes(OMS_PERMISSION_ADMIN),
    canViewOmsReport: scopes.includes(OMS_PERMISSION_VIEW_REPORT) || scopes.includes(OMS_PERMISSION_MANAGE_INVENTORY) || scopes.includes(OMS_PERMISSION_ADMIN),
  };
}
